export default "__VITE_ASSET___Xf$$$80__"